module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fb-Gc-Hc-Ia.0e076fcf.png";